import { Component } from "@angular/core";
import { NavController } from "@ionic/angular";
import { BackNativeService } from "../service/comunicator-native/back-native/back-native";
import { ReturnNativeService } from "../service/comunicator-native/return-native/return-native";
import { DomainDataType } from "../service/domains/model/domain-data-type";
import { DomainOrigin } from "../service/domains/model/domain-origin";
import { JourneyService } from "../service/journey/journey.service";

@Component({
  template: "",
})
export class DefaultPageComponent {
  public headerId: string;
  public ariaHidden = true;
  public edit = false;
  public domainOrigin = DomainOrigin.BrokerMobile;
  public domainDataType: DomainDataType = DomainDataType.Generic;

  constructor(
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    public router: NavController,
    public returnNativeService: ReturnNativeService
  ) {}

  public back() {
    const previousPage = this.journeyService.getPreviousRoute(this.getPageId());
    if (previousPage) {
      this.router.navigateBack(previousPage);
    } else {
      this.backJourney();
    }
  }

  public getPageId(): string {
    throw new Error(
      "É necessário implementar o id da pagina, sobrescreva o metodo getPageId"
    );
  }

  public headerFocus(idTitle?: string) {
    const ios = document.querySelector(".plt-ios");
    const time = ios ? 100 : 200;

    if (ios) {
      document.body.setAttribute("aria-hidden", "true");
      setTimeout(() => {
        document.body.removeAttribute("aria-hidden");
        this.headerFocusBrowser(time, idTitle);
      }, 300);
    } else {
      this.headerFocusBrowser(time, idTitle);
    }
  }

  headerFocusBrowser(time: number, idTitle?: string) {
    setTimeout(() => {
      const idHeader = document.getElementById(
        idTitle ? idTitle : this.headerId
      );
      if (idTitle) {
        idHeader?.setAttribute("tabindex", "0");
      }
      idHeader?.focus();
    }, time);
  }

  pageFocus(id: string) {
    const item: HTMLElement = document.getElementById(id);

    if (document.querySelector(".plt-ios")) {
      document.body.setAttribute("aria-hidden", "true");
      setTimeout(() => {
        document.body.removeAttribute("aria-hidden");
        setTimeout(() => {
          item?.blur();
          item?.focus();
        }, 10);
      }, 1000);
    } else {
      item?.focus();
    }
  }

  focusPageWithDetail(_id: string) {
    this.headerFocus();
  }

  shownContent() {
    setTimeout(() => (this.ariaHidden = false), 100);
  }

  public nextPage() {
    const nextPage = this.journeyService.getNextRoute(this.getPageId());
    if (nextPage) {
      this.router.navigateForward(nextPage);
    } else {
      this.endJourney();
    }
  }

  public endJourney() {
    if (this.journeyService.selectedTrack.isUncoupled()) {
      this.journeyService.finishDataEvent();
    }
    if (this.journeyService.selectedTrack.isBackHeader()) {
      this.backJourney();
    } else {
      this.returnNativeService.returnCommunicator();
    }
  }

  public backJourney() {
    this.backNativeService.backHeaderCommunicator();
  }

  public editFieldInvest(field: string, fieldUndefined: string, step: string) {
    if (!this.journeyService.selectedTrack.isUncoupled()) {
      setTimeout(() => {
        let editField = [];
        let nullEmpty = "";
        let data = null;
        let editEmptyValue = null;
        let firstEdit = [];
        let editDataFirst = [];

        if (step === "personalData") {
          if (
            this.journeyService.registratioJourney?.data.personalData?.editData
          ) {
            editField =
              this.journeyService.registratioJourney.data.personalData?.editData.find(
                (x) => x === field
              );
          }
          data = this.journeyService.registratioJourney?.data?.personalData;
          editEmptyValue = this.filterUndefined(data);
          nullEmpty = editEmptyValue.find((x) => x === fieldUndefined);

          if (fieldUndefined === "dateInvalid") {
            nullEmpty = "dateOfBirth";
          }

          if (nullEmpty) {
            if (
              !this.journeyService.registratioJourney?.data.personalData?.firstEdit?.find(
                (x) => x === nullEmpty
              )
            ) {
              this.journeyService.registratioJourney?.data.personalData?.firstEdit?.push(
                nullEmpty
              );
            }
          }

          firstEdit =
            this.journeyService.registratioJourney?.data.personalData
              ?.firstEdit;
          editDataFirst = this.firstEditField(firstEdit, fieldUndefined);

          // Regra verificando campos com string vazia e liberando para edição [expeditionState]
          for (const item in data) {
            if (typeof data[item] === "string" && data[item] === "") {
              switch (item) {
                case "expeditionState":
                  firstEdit.push(item);
                  break;
                default:
                  break;
              }
            }
          }
        }

        if (step === "maritalStatus") {
          if (
            this.journeyService.registratioJourney?.data.maritalStatus?.editData
          ) {
            editField =
              this.journeyService.registratioJourney.data.maritalStatus?.editData.find(
                (x) => x === field
              );
          }
          data = this.journeyService.registratioJourney?.data?.maritalStatus;
          editEmptyValue = this.filterUndefined(data);
          nullEmpty = editEmptyValue.find((x) => x === fieldUndefined);

          if (nullEmpty) {
            this.journeyService.registratioJourney?.data.maritalStatus?.firstEdit?.push(
              nullEmpty
            );
          }

          firstEdit =
            this.journeyService.registratioJourney?.data.maritalStatus
              ?.firstEdit;
          editDataFirst = this.firstEditField(firstEdit, fieldUndefined);
        }

        if (step === "address") {
          if (this.journeyService.registratioJourney?.data.address?.editData) {
            editField =
              this.journeyService.registratioJourney.data.address?.editData.find(
                (x) => x === field
              );
          }
          data = this.journeyService.registratioJourney?.data?.address;
          editEmptyValue = this.filterUndefined(data);
          nullEmpty = editEmptyValue.find((x) => x === fieldUndefined);

          if (nullEmpty) {
            this.journeyService.registratioJourney?.data.address?.firstEdit?.push(
              nullEmpty
            );
          }

          firstEdit =
            this.journeyService.registratioJourney?.data.address?.firstEdit;
          editDataFirst = this.firstEditField(firstEdit, fieldUndefined);
        }

        if (step === "professionalData") {
          if (
            this.journeyService.registratioJourney?.data.professionalData
              ?.editData
          ) {
            editField =
              this.journeyService.registratioJourney.data.professionalData?.editData.find(
                (x) => x === field
              );
          }
          data = this.journeyService.registratioJourney?.data?.professionalData;
          editEmptyValue = this.filterUndefined(data);
          nullEmpty = editEmptyValue.find((x) => x === fieldUndefined);

          if (nullEmpty) {
            this.journeyService.registratioJourney?.data.professionalData?.firstEdit?.push(
              nullEmpty
            );
          }

          firstEdit =
            this.journeyService.registratioJourney?.data.professionalData
              ?.firstEdit;
          editDataFirst = this.firstEditField(firstEdit, fieldUndefined);
        }

        if (step === "income") {
          if (
            this.journeyService.registratioJourney?.data.incomeEquity?.editData
          ) {
            editField =
              this.journeyService.registratioJourney.data.incomeEquity?.editData.find(
                (x) => x === field
              );
          }
          data = this.journeyService.registratioJourney?.data?.incomeEquity;
          editEmptyValue = this.filterUndefined(data);
          nullEmpty = editEmptyValue.find((x) => x === fieldUndefined);

          if (nullEmpty) {
            this.journeyService.registratioJourney?.data.incomeEquity?.firstEdit?.push(
              nullEmpty
            );
          }

          firstEdit =
            this.journeyService.registratioJourney?.data.incomeEquity
              ?.firstEdit;
          editDataFirst = this.firstEditField(firstEdit, fieldUndefined);
        }

        if ((editField && editField.length > 0) || nullEmpty || editDataFirst) {
          this.edit = true;
        } else {
          this.edit = false;
        }
      }, 500);
    } else {
      this.edit = true;
    }
  }

  filterUndefined(data) {
    let itemUndefined = [];
    for (let item in data) {
      if (data[item] === undefined || data[item] === "0") {
        itemUndefined.push(item);
      }
    }
    return itemUndefined;
  }

  firstEditField(firstEdit, field) {
    let item = null;
    if (firstEdit && firstEdit.length > 0) {
      item = firstEdit.find((x) => x === field);
    }
    return item;
  }

  public configureDomain(
    _domainOrigin?: DomainOrigin,
    _domainDataType?: DomainDataType
  ) {
    if (_domainOrigin) {
      this.domainOrigin = _domainOrigin;
    } else {
      this.domainOrigin = this.journeyService.getCurrentTrack(this.headerId)
        ?.parameters?.domainOrigin
        ? this.journeyService.getCurrentTrack(this.headerId)?.parameters
            ?.domainOrigin
        : this.domainOrigin;
    }
    this.domainDataType = _domainDataType
      ? _domainDataType
      : DomainDataType.Generic;
  }
}
